// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2VU52","colMin":"styles_colMin__M8b4L","colCheckbox":"styles_colCheckbox__Lg1GJ"};